<template>

  <div class="container">
    <h1>Club Graph Page</h1>

    <div class="selected-user">
      <router-link v-if="selected_user" :to="`/admin/user/${selected_user._id}`">
        <ProfilePicture :user="selected_user" :size="20"></ProfilePicture> {{selected_user.username}}
      </router-link>
    </div>

    <v-network-graph
        v-if="nodes && edges"
        class="graph"
        ref="graph"
        v-model:selected-nodes="selectedNodes"
        :nodes="nodes"
        :edges="edges"
        :configs="configs"
    >

      <defs>
        <!--
          Define the path for clipping the face image.
          To change the size of the applied node as it changes,
          add the `clipPathUnits="objectBoundingBox"` attribute
          and specify the relative size (0.0~1.0).
        -->
        <clipPath id="faceCircle" clipPathUnits="objectBoundingBox">
          <circle cx="0.5" cy="0.5" r="0.5" />
        </clipPath>

        <clipPath id="clubRect" clipPathUnits="objectBoundingBox">
          <rect width="1" height="1" rx="0.25" ry="0.25" />
        </clipPath>
      </defs>

      <!-- Replace the node component -->
      <template #override-node="{ nodeId, scale, config, ...slotProps }">
        <!-- circle for filling background -->
        <circle
            class="face-circle"
            :r="config.radius * scale"
            fill="#ffffff"
            v-bind="slotProps"
        />
        <!--
          The base position of the <image /> is top left. The node's
          center should be (0,0), so slide it by specifying x and y.
        -->
        <image
            class="face-picture"
            :x="-config.radius * scale"
            :y="-config.radius * scale"
            :width="config.radius * scale * 2"
            :height="config.radius * scale * 2"
            :xlink:href="nodes[nodeId].picture"
            :clip-path="(nodes[nodeId].type === 'user') ? 'url(#faceCircle)' : 'url(#clubRect)'"
        />
        <!-- circle for drawing stroke -->
        <circle
            v-if="nodes[nodeId].type === 'user'"
            class="face-circle"
            :r="config.radius * scale"
            fill="none"
            :stroke="config.strokeColor"
            :stroke-width="config.strokeWidth * scale"
            v-bind="slotProps"
        />
        <rect
            v-else
            class="club-rect"
            :rx="config.radius * 0.25 * scale * 2"
            :ry="config.radius * 0.25 * scale * 2"
            :x="-config.radius * scale"
            :y="-config.radius * scale"
            :width="config.radius * scale * 2"
            :height="config.radius * scale * 2"
            fill="none"
            :stroke="config.strokeColor"
            :stroke-width="config.strokeWidth * scale"
        />
      </template>

    </v-network-graph>
  </div>

</template>


<script>

import { VNetworkGraph } from "v-network-graph"
import { ForceLayout } from "v-network-graph/lib/force-layout"
import "v-network-graph/lib/style.css"
import axios from "axios";
import ProfilePicture from "@/components/profile/ProfilePicture.vue";

export default {
  name: "AdminClubGraphPage",
  components: {ProfilePicture, VNetworkGraph},
  data() {
    return {
      nodes: null,
      edges: null,
      configs: null,
      selectedNodes: []
    }
  },
  computed: {
    selected_user() {
      const selectedNodeKey = this.selectedNodes?.[0];
      if ( !selectedNodeKey ) {
        return null;
      }
      const selectedNode = this.nodes[selectedNodeKey];
      return {
        _id: selectedNodeKey,
        picture_url: selectedNode.picture_url,
        username: selectedNode.name
      }
    }
  },
  async created() {
    const isDarkMode = ( document.documentElement?.getAttribute('data-bs-theme') === 'dark' );

    this.configs = {
      node: {
        selectable: true,
        draggable: false,
        normal: {
          radius: node => (node.type === "club" ? 20 : 16),
          strokeWidth: 1,
          strokeColor: "#e1bb28",
          //type: node => (node.type === "club" ? 'rect' : 'circle'),
          //radius: node => (node.type === "club" ? 24 : 16),
          //strokeWidth: node => (node.type === "club" ? 3 : 1),
          //strokeColor: node => (node.type === "club" ? "#e1bb28" : "#808080"),
        },
        label: {
          color: (isDarkMode ? '#ffffff' : '#000000'),
        },
      },
      view: {

        layoutHandler: new ForceLayout({
          createSimulation: (d3, nodes, edges) => {
            // d3-force parameters
            const forceLink = d3.forceLink(edges).id(d => d.id)
            return d3
                .forceSimulation(nodes)
                .force("edge", forceLink.distance(20))
                .force("charge", d3.forceManyBody())
                .force("collide", d3.forceCollide(50).strength(0.2))
                .force("center", d3.forceCenter().strength(0.05))

                // todo: enforce bounding box
                // .force("bounds",() => {
                //     const radius = 500;
                //
                //     for (let node of nodes) {
                //       // Of the positions exceed the box, set them to the boundary position.
                //       // You may want to include your nodes width to not overlap with the box.
                //       node.x = Math.max(-radius, Math.min(radius, node.x));
                //       node.y = Math.max(-radius, Math.min(radius, node.y));
                //     }
                //   }
                // )


                .alphaMin(0.001)

            // default values
            // return d3
            //   .forceSimulation(nodes)
            //   .force("edge", forceLink.distance(100))
            //   .force("charge", d3.forceManyBody())
            //   .force("collide", d3.forceCollide(50).strength(0.2))
            //   .force("center", d3.forceCenter().strength(0.05))
            //   .alphaMin(0.001)
          }
        })
      }
    };

    return axios.get(`/api/admin/club-membership-connections`)
        .then(response => {
          console.log('response', response.data);
          this.nodes = response.data.nodes;
          this.edges = response.data.edges;

          //setTimeout(this.fitContent, 2000);
        })
        .catch(err => {
          console.log(err);
        })
  },
  methods: {

    fitContent() {
      //console.log('graph', this.$refs.graph);
      this.$refs.graph.fitToContents();
    }
  }
}
</script>


<style scoped>
.graph {
  width: 100%;
  height: calc(90vh - var(--mol-footerbar-height));
  border: 1px solid #000;
}
.selected-user {
  margin: 10px;
  text-align: end;
}
</style>